jQuery(document).ready(function($){

    function tile_resize() {
        $(this).css("height", "auto");
        var width = $(this).width();
        $(this).height(width);
    }

    function resize_tiles() {
        $(".shape-square").each(tile_resize);
    }

    resize_tiles();

    $(window).resize(resize_tiles);

    $('body').on('DOMSubtreeModified', '.shape-square', tile_resize);

});
